(function () {
  'use strict';

  function init() {
    initialiseLogo();
    initialiseDropdown();
    initialiseBulkChoices();
    initialiseEnquirySelection();
    initialiseFaqAccordion();
    initialiseForm('cg-personalised-form', 'personalised');
    initialiseForm('cg-bulk-form', 'bulk');
  }

  function initialiseLogo() {
    var fileInput = document.getElementById('cg-logo-file');
    var previewWrap = document.getElementById('cg-logo-preview');
    var previewImg = document.getElementById('cg-logo-upload-preview-img');
    var previewName = document.getElementById('cg-logo-preview-name');
    var removeBtn = document.getElementById('cg-logo-remove-btn');
    var uploadArea = document.getElementById('cg-logo-upload-area');

    if (!fileInput || !previewWrap || !previewImg || !previewName || !removeBtn || !uploadArea) return;

    uploadArea.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('label')) return;
      fileInput.click();
    });

    fileInput.addEventListener('change', function () {
      var file = fileInput.files[0];
      if (!file) return;

      if (file.size > 5 * 1024 * 1024) {
        alert('That file is too large. Please use a file under 5MB.');
        fileInput.value = '';
        return;
      }

      var isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);

      if (isPdf) {
        previewImg.removeAttribute('src');
        previewImg.style.display = 'none';
        previewName.textContent = file.name + ' (PDF selected)';
        previewWrap.style.display = 'block';
        uploadArea.classList.add('has-preview', 'has-pdf-preview');
        return;
      }

      uploadArea.classList.remove('has-pdf-preview');
      var reader = new FileReader();
      reader.onload = function (e) {
        previewImg.src = e.target.result;
        previewImg.style.display = 'block';
        previewName.textContent = file.name;
        previewWrap.style.display = 'block';
        uploadArea.classList.add('has-preview');
      };
      reader.readAsDataURL(file);
    });

    removeBtn.addEventListener('click', function () {
      fileInput.value = '';
      previewImg.removeAttribute('src');
      previewImg.style.display = 'none';
      previewName.textContent = '';
      previewWrap.style.display = 'none';
      uploadArea.classList.remove('has-preview', 'has-pdf-preview');
    });
  }

  function initialiseDropdown() {
    var dropdown = document.getElementById('cg-personalised-quantity-dropdown');
    if (!dropdown) return;

    var selectedBtn = dropdown.querySelector('.cg-dropdown-selected');
    var selectedText = selectedBtn.querySelector('span');
    var optionsList = dropdown.querySelector('.cg-dropdown-options');
    var hiddenInput = document.getElementById('cg-personalised-quantity-value');
    var optionBtns = dropdown.querySelectorAll('.cg-dropdown-option');

    selectedBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = optionsList.classList.contains('is-open');
      optionsList.classList.toggle('is-open', !isOpen);
      selectedBtn.setAttribute('aria-expanded', String(!isOpen));
    });

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        hiddenInput.value = btn.getAttribute('data-value');
        selectedText.textContent = btn.textContent;
        selectedBtn.classList.add('has-value');
        dropdown.classList.remove('error');
        optionsList.classList.remove('is-open');
        selectedBtn.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function () {
      optionsList.classList.remove('is-open');
      selectedBtn.setAttribute('aria-expanded', 'false');
    });
  }

  function initialiseBulkChoices() {
    var form = document.getElementById('cg-bulk-form');
    if (!form) return;

    var categoryInputs = form.querySelectorAll('input[name="bulk_gifting_option"]');

    function syncProductGroups() {
      categoryInputs.forEach(function (categoryInput) {
        var productGroup = document.getElementById(categoryInput.getAttribute('data-product-group'));
        if (!productGroup) return;

        var showProducts = categoryInput.checked;
        productGroup.hidden = !showProducts;

        productGroup.querySelectorAll('input, button').forEach(function (control) {
          var unavailable = control.getAttribute('data-unavailable') === 'true';
          control.disabled = !showProducts || unavailable;
        });

        if (!categoryInput.checked) {
          productGroup.querySelectorAll('input[type="checkbox"]').forEach(function (productInput) {
            productInput.checked = false;
          });
        }
      });
    }

    categoryInputs.forEach(function (input) {
      input.addEventListener('change', syncProductGroups);
    });
    syncProductGroups();
  }

  function initialiseEnquirySelection() {
    var intro = document.getElementById('cg-enquiry-intro');
    var formGrid = document.getElementById('cg-form-grid');
    var personalisedCard = document.getElementById('cg-personalised-form-card');
    var bulkCard = document.getElementById('cg-bulk-form-card');
    var personalisedLinks = document.querySelectorAll('.cg-personalised-enquire-cta');
    var stickyCta = document.getElementById('cg-sticky-personalised-cta');
    var heroCta = document.getElementById('cg-enquire-cta');
    var bulkSection = document.getElementById('bulk-gifting');
    var bulkReached = false;

    if (!intro || !formGrid || !personalisedCard || !bulkCard) return;

    function setStickyVisible(visible) {
      if (!stickyCta) return;
      stickyCta.hidden = !visible;
      stickyCta.setAttribute('aria-hidden', String(!visible));
      stickyCta.classList.toggle('is-visible', visible);
      var page = document.querySelector('.cg-page');
      if (page) page.classList.toggle('has-sticky-enquiry', visible);
    }

    setStickyVisible(false);

    function selectForm(mode, shouldScroll) {
      var isBulk = mode === 'bulk';
      personalisedCard.hidden = isBulk;
      bulkCard.hidden = !isBulk;
      formGrid.hidden = false;
      personalisedCard.setAttribute('aria-hidden', String(isBulk));
      bulkCard.setAttribute('aria-hidden', String(!isBulk));
      intro.textContent = copy[isBulk ? 'bulk' : 'personalised'];
      setStickyVisible(false);

      if (shouldScroll) {
        (isBulk ? bulkCard : personalisedCard).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function updateStickyCta() {
      if (!stickyCta || !heroCta) return;
      if (!formGrid.hidden || bulkReached) {
        setStickyVisible(false);
        return;
      }

      var bulkRect = bulkSection ? bulkSection.getBoundingClientRect() : null;
      if (bulkRect && bulkRect.top <= window.innerHeight * 0.85) {
        bulkReached = true;
        setStickyVisible(false);
        return;
      }

      setStickyVisible(heroCta.getBoundingClientRect().bottom < 0);
    }

    var stickyScrollPending = false;
    function requestStickyUpdate() {
      if (stickyScrollPending) return;
      stickyScrollPending = true;
      window.requestAnimationFrame(function () {
        stickyScrollPending = false;
        updateStickyCta();
      });
    }

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    updateStickyCta();

    var copy = {
      initial: 'Choose the enquiry that best matches your gifting plans.',
      personalised: 'Complete the form below to tell us about your personalised screw can mini order. Our team will be in touch the next working day with a full quote and label proof details.',
      bulk: 'Complete the form below to tell us about your bulk t leaf T gifting order. Our team will be in touch the next working day with pricing, product details and the next steps.'
    };
    var bulkLinks = document.querySelectorAll('.cg-bulk-enquire-cta');

    function bindBulkLink(bulkLink) {
      bulkLink.addEventListener('click', function (e) {
        e.preventDefault();
        selectForm('bulk', true);
      });
    }

    personalisedLinks.forEach(function (personalisedLink) {
      personalisedLink.addEventListener('click', function (e) {
        e.preventDefault();
        selectForm('personalised', true);
      });
    });

    bulkLinks.forEach(bindBulkLink);

    formGrid.hidden = true;
    personalisedCard.hidden = true;
    bulkCard.hidden = true;
    personalisedCard.setAttribute('aria-hidden', 'true');
    bulkCard.setAttribute('aria-hidden', 'true');
    intro.textContent = copy.initial;
  }

    function initialiseFaqAccordion() {
    var triggers = document.querySelectorAll('.cg-faq-accordion .tlt-accordion-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var item = trigger.closest('.tlt-accordion-item');
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel && item) panel = item.querySelector('.tlt-accordion-body');
      if (!panel) return;

      if (panel.id) trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var nextState = !isOpen;

        trigger.setAttribute('aria-expanded', String(nextState));
        panel.classList.toggle('open', nextState);
        panel.setAttribute('aria-hidden', String(!nextState));
      });
    });
  }

  function initialiseForm(formId, mode) {
    var form = document.getElementById(formId);
    var submitBtn = form ? form.querySelector('button[id$="submit-btn"]') : null;
    var statusEl = document.getElementById(formId.replace('-form', '-form-status'));

    if (!form || !submitBtn || !statusEl) return;

    var endpoint = form.getAttribute('action');
    var gotcha = form.querySelector('input[name="_gotcha"]');

    function showStatus(message, type) {
      statusEl.textContent = message;
      statusEl.className = 'cg-form-status ' + type;
      statusEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function clearStatus() {
      statusEl.textContent = '';
      statusEl.className = 'cg-form-status';
    }

    submitBtn.addEventListener('click', function () {
      clearStatus();

      if (gotcha && gotcha.value) return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (mode === 'bulk') {
        var bulkChecks = form.querySelectorAll('input[name="bulk_gifting_option"]:checked');
        if (bulkChecks.length === 0) {
          showStatus('Please select at least one gifting option.', 'error');
          return;
        }

        var missingProductCategories = [];
        bulkChecks.forEach(function (categoryInput) {
          var productGroup = document.getElementById(categoryInput.getAttribute('data-product-group'));
          var productChecks = productGroup ? productGroup.querySelectorAll('input[type="checkbox"]:checked') : [];
          if (!productChecks.length) missingProductCategories.push(categoryInput.value);
        });

        if (missingProductCategories.length) {
          showStatus('Please select at least one product for ' + missingProductCategories.join(', ') + '.', 'error');
          return;
        }
      } else {
        var teaChecks = form.querySelectorAll('input[name="tea_selection"]:checked');
        if (teaChecks.length === 0) {
          showStatus('Please select at least one tea.', 'error');
          return;
        }

        var quantityInput = document.getElementById('cg-personalised-quantity-value');
        if (!quantityInput || !quantityInput.value) {
          var dropdown = document.getElementById('cg-personalised-quantity-dropdown');
          if (dropdown) dropdown.classList.add('error');
          showStatus('Please select a quantity.', 'error');
          return;
        }
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      var formData = new FormData(form);
      var logoInput = form.querySelector('input[name="logo"]');
      if (logoInput && (!logoInput.files || !logoInput.files.length)) formData.delete('logo');

      fetch(endpoint, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.text().then(function (text) {
            var data = {};
            try { data = text ? JSON.parse(text) : {}; } catch (e) { data = {}; }

            if (response.ok) {
              form.innerHTML = '';
              showStatus('Thank you for your enquiry. Our team will be in touch the next working day with a full quote and the next steps.', 'success');
              return;
            }

            var errorList = Array.isArray(data.errors) ? data.errors : [];
            var fileUploadError = errorList.some(function (err) {
              return String(err.message || '').toLowerCase().indexOf('file uploads not permitted') !== -1;
            });

            if (fileUploadError) {
              showStatus('Your enquiry could not include the design / artwork because this Formspree form is not currently permitted to receive file uploads. Please check the Formspree plan and try again without the file if needed.', 'error');
            } else if (errorList.length) {
              showStatus('There was a problem submitting your enquiry: ' + errorList.map(function (err) {
                return (err.field ? err.field + ': ' : '') + err.message;
              }).join(', '), 'error');
            } else {
              showStatus('There was a problem submitting your enquiry. Please try again or email us at hello@tleaft.co.nz.', 'error');
            }

            submitBtn.disabled = false;
            submitBtn.textContent = mode === 'bulk' ? 'Submit bulk gifting enquiry' : 'Submit personalised enquiry';
          });
        })
        .catch(function () {
          showStatus('There was a connection problem. Please check your internet connection and try again, or email us at hello@tleaft.co.nz.', 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = mode === 'bulk' ? 'Submit bulk gifting enquiry' : 'Submit personalised enquiry';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
